/**
 * Los `value` de rol NUNCA cambian — son los que vive el backend
 * (`ROL_CONTADURIA`/`ROL_COMPRADOR` en function_app.py) y los que trae el
 * claim `roles` del token JWT. Ver docs/Decisions.md del backend,
 * 04/08/2026: "Rol 'Comprador' se muestra como 'Aprobador'" — decisión
 * explícita de NO tocar el value ni el código, solo la etiqueta visible.
 *
 * Esta es la ÚNICA convención entre los dos repos (backend/Frontend) que no
 * se sincroniza por código — es manual. Si el backend algún día cambia el
 * value real (no debería, sin una decisión nueva documentada), hay que
 * actualizar esto a mano.
 */

export const ROLE_CONTADURIA = "Contaduria" as const;
export const ROLE_COMPRADOR = "Comprador" as const;
/**
 * [NUEVO 01/09/2026] Rol de la bandeja "Control de facturas para pagar".
 * Ve SOLO esa bandeja — no participa del circuito de aprobación de facturas.
 * Contaduría también la ve, sin necesidad de tener este rol.
 */
export const ROLE_CONTROL_PAGOS = "ControlPagos" as const;

/** [NUEVO 04/11/2026] Aprueba lotes de pago (2 aprobaciones de usuarios distintos). */
export const ROLE_APROBADOR_PAGOS = "AprobadorPagos" as const;

export type AppRole =
  | typeof ROLE_CONTADURIA
  | typeof ROLE_COMPRADOR
  | typeof ROLE_CONTROL_PAGOS
  | typeof ROLE_APROBADOR_PAGOS;

/** Etiqueta visible en la UI — nunca usar el `value` directo en texto. */
export const ROLE_LABELS: Record<AppRole, string> = {
  [ROLE_CONTADURIA]: "Contaduría",
  [ROLE_COMPRADOR]: "Aprobador", // ver nota arriba — el value sigue siendo "Comprador"
  [ROLE_CONTROL_PAGOS]: "Control de Pagos",
  [ROLE_APROBADOR_PAGOS]: "Aprobador de pagos",
};

export function roleLabel(role: AppRole): string {
  return ROLE_LABELS[role] ?? role;
}
